import { render, staticRenderFns } from "./GaaLoginRecords.vue?vue&type=template&id=492ba7ba&"
import script from "./GaaLoginRecords.vue?vue&type=script&lang=js&"
export * from "./GaaLoginRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports